import React, { FC } from 'react'

import {
  CreditCardManager,
  ExpenseBucket,
  PointsCard,
  ReferralCreditsCard,
} from 'src/payments/components'

import styles from './styles'
import { useActions, useEffect, useQueries, useVertical } from '../../../hooks'
import { getAccount } from 'src/graphql'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { DefaultError } from 'src/chrome'
import { Anchor, Spacer, Text } from '@sendoutcards/quantum-design-ui'

const PaymentSettings: FC = () => {
  const actions = useActions()
  const [account] = useQueries(getAccount())
  const isClientSOC = useVertical().id === 'soc'

  useEffect(() => {
    actions.updatedAccount(account)
  }, [actions, account])

  return (
    <div css={styles.paymentWrapper}>
      <Text type="title">My Wallet</Text>
      <Spacer space="x4" />
      <div css={styles.cardsContainer}>
        <div css={styles.cardSection}>
          <div css={styles.cardHeader}>
            <Text type="body" color="primaryHeading" weight="bold">
              Primary Payment
            </Text>
            <Spacer space="x3" />
            <Text type="caption">
              Used for purchasing products and monthly subscriptions.
            </Text>
          </div>
          <CreditCardManager />
        </div>
        {isClientSOC && (
          <div css={styles.cardSection}>
            <div css={styles.cardHeader}>
              <Text type="body" color="primaryHeading" weight="bold">
                Expense Bucket
              </Text>
              <Spacer space="x3" />
              <Text type="caption">
                Money in your expense bucket is used for sending cards and
                gifts, including postage, shipping, and handling.
              </Text>
            </div>
            <ExpenseBucket account={account} />
          </div>
        )}
      </div>
      <div css={styles.cardsContainer}>
        <div css={styles.cardSection}>
          <div css={styles.cardHeader}>
            <Text type="body" color="primaryHeading" weight="bold">
              Your Referral Credits
            </Text>
            <Spacer space="x3" />
            <Text type="caption">
              Referral credits can be used for sending cards and gifts.
            </Text>
            <Spacer space="x1" />
            <Anchor
              href="https://www.sendoutcards.com/resources/customer-referral-program/"
              target="_blank"
              isDecorated={true}
            >
              <Text type="caption" color="anchorBlue">
                Learn more about the customer referral program.
              </Text>
            </Anchor>
          </div>
          <ReferralCreditsCard />
        </div>
        {!account.isNewUser && isClientSOC && account.points.amount > 0 && (
          <div css={styles.cardSection}>
            <div css={styles.cardHeader}>
              <Text type="body" color="primaryHeading" weight="bold">
                Your Points
              </Text>
              <Spacer space="x3" />
              <Text type="caption">
                Points are used for sending cards and gifts.
              </Text>
            </div>
            <PointsCard />
          </div>
        )}
      </div>
    </div>
  )
}

export default suspenseBoundary({
  component: PaymentSettings,
  unresolved: (
    <Text type="caption" alignment="center">
      Loading account...
    </Text>
  ),
  failure: DefaultError,
})
